// PermisosPorModulo.js
import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import ConfigCheckbox from "../../../Components/Common/ConfigCheckbox";

const PermisosPorModulo = ({ profileId, submoduleId }) => {
  const [permissions, setPermissions] = useState([]);

  // 1. Cargar los permisos para un perfil y submódulo específicos
  useEffect(() => {
    if (submoduleId == "bodega") {
      setPermissions([
        {
          key: "view_products",
          label: "Ver Productos",
          is_enabled: true,
        },
        {
          key: "edit_products",
          label: "Editar Productos",
          is_enabled: false,
        },
      ]);
    } else if (submoduleId == "caja") {
      setPermissions([
        {
          key: "view_sales",
          label: "Ver Ventas",
          is_enabled: true,
        },
        {
          key: "edit_sales",
          label: "Editar Ventas",
          is_enabled: false,
        },
      ]);
    }
  }, [profileId, submoduleId]);

  // 2. Manejar el cambio de estado y notificar al backend
  const handleCheckboxChange = (event) => {
    const { name: permissionKey, checked } = event.target;

    setPermissions((prevPermissions) =>
      prevPermissions.map((permission) =>
        permission.key === permissionKey
          ? { ...permission, is_enabled: checked }
          : permission
      )
    );

    // Lógica para guardar el cambio en la base de datos
    // La API debería esperar el ID del perfil, la clave del permiso y el nuevo valor
    savePermissionChange(profileId, permissionKey, checked);
  };

  // Función (posiblemente con debounce) para enviar cambios a la API
  const savePermissionChange = async (profileId, permissionKey, isEnabled) => {
    // await fetch(`/api/profiles/${profileId}/permissions`, {
    // method: 'POST', // o 'PUT'
    // headers: { 'Content-Type': 'application/json' },
    // body: JSON.stringify({ key: permissionKey, enabled: isEnabled }),
    // });
  };

  // 3. Renderizar la lista de checkboxes
  return (
    <Row>
      <Col md={6}>
        <div>
          <p className="text-muted">{submoduleId}</p>
          <div>
            {permissions.map((permission) => (
              <ConfigCheckbox
                key={permission.key}
                name={permission.key}
                label={permission.label}
                checked={permission.is_enabled}
                onChange={handleCheckboxChange}
              />
            ))}
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default PermisosPorModulo;
